import { useBroadcastChannel } from "../hooks/use-broadcast-channel";
import { useActiveTab } from "../hooks/use-active-tab";
import { goBlank } from "../utils/auth";
import { useEffect } from "react";
import { SessionInactiveBroadcast } from "../components/InactiveAlert";
import React from "react";

export const SingleTab: React.FC<any> = () => {
  const isActiveTab = useActiveTab();

  const { postMessage } = useBroadcastChannel<SessionInactiveBroadcast>(
    "session:remove:inactive:tabs",
    (data: SessionInactiveBroadcast) => {
      if (data.kind === "session:remove:inactive:tabs") {
        if (!isActiveTab) {
          goBlank();
        }
      }
    }
  );

  useEffect(() => {
    if (isActiveTab) {
      postMessage({ kind: "session:remove:inactive:tabs" });
    }
  }, [isActiveTab]);
  return <span></span>;
};
